module.exports = __webpack_public_path__ + "img/payment-visa.c66edc95.png";